<template>
  <v-app :class="{ 'vendedora-app': esRutaVendedora }">
    <!-- Router -->
    <v-main :class="{ 'vendedora-main': esRutaVendedora }">
      <router-view/>
    </v-main>

    <!-- Footer  -->
    <v-footer app class="pa-0 lms-app-footer" v-if="getLogeadoLMS && !esRutaVendedora">
      <Navegador/>
    </v-footer>

     <NoInternet v-if="!estatusInternet"/>
     <BloqueoCiclo/>

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
        <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
        <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
      </symbol>
    </svg>

  </v-app>
</template>

<script>
  // Push notifications desactivadas
  // import {
  //   ActionPerformed,
  //   PushNotificationSchema,
  //   PushNotifications,
  //   Token,
  // } from '@capacitor/push-notifications';
  import { Device } from '@capacitor/device';

  // Componentes
  import Navegador  from '@/components/Navegador.vue'
  import NoInternet from '@/components/alertas/NoInternet.vue'
  import BloqueoCiclo from '@/components/alertas/BloqueoCiclo.vue'

  // Librerías y más
  import { mapGetters, mapActions } from 'vuex'

  // Capacitor
  import { Network } from '@capacitor/network';

  export default {
    components:{
      Navegador,
      NoInternet,
      BloqueoCiclo,
    },

    name: 'App',

    data: () => ({
      drawer: true,
      drawer2:false,
      mini:false,
      escuela:2,
      color_active:'',
      estatusInternet: false
    }),

    async created ( ){
      const info = await Device.getInfo()
      if (info.platform === 'ios') {
        document.documentElement.classList.add('platform-ios')
        document.body.classList.add('platform-ios')
      }

      if( this.getUsuarioLMS ){
        const payload = { id: this.getUsuarioLMS.id, dispositivo: info.operatingSystem }
        this.$http.post('usuario.tipodispositivo', payload).then(() => {
          this.cargar = false
        }).catch(() => {
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      }

      Network.addListener('networkStatusChange', status => {
        this.estatusInternet = status.connected ;
      });

      const status = await Network.getStatus();
      this.estatusInternet = status.connected ;
    },


    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),

      salir(){
        this.salirLogin()
      },

      
    },

    computed:{
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),
      esRutaVendedora () {
        const p = this.$route && this.$route.path
        return !!(p && String(p).startsWith('/vendedora'))
      },
    },

    watch: {
      esRutaVendedora: {
        immediate: true,
        handler (v) {
          if (typeof document === 'undefined') return
          document.documentElement.classList.toggle('vendedora-lock', !!v)
          document.body.classList.toggle('vendedora-lock', !!v)
        },
      },
    },

    beforeDestroy () {
      if (typeof document !== 'undefined') {
        document.documentElement.classList.remove('vendedora-lock')
        document.body.classList.remove('vendedora-lock')
      }
    },
  };
</script>

<style>
html.vendedora-lock,
html.vendedora-lock body,
html.vendedora-lock #app {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100vh;
  max-height: 100dvh;
  overflow: hidden !important;
  overscroll-behavior: none;
}
.vendedora-app.v-application,
.vendedora-app .v-application--wrap {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
.vendedora-main.v-main {
  padding: 0 !important;
  flex: 1 1 0% !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
.vendedora-main .v-main__wrap {
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  overflow: hidden !important;
}

/* iOS: footer hasta el borde inferior (home indicator) */
html.platform-ios .lms-app-footer {
  padding-bottom: constant(safe-area-inset-bottom) !important;
  padding-bottom: env(safe-area-inset-bottom, 0px) !important;
  background: #ffffff !important;
}

html.platform-ios .lms-app-footer .v-bottom-navigation {
  background: #ffffff !important;
}
</style>

